import type { AppointmentEmail } from '../api/client'

// What each email is called on the sheet. A kind the app doesn't know yet (a
// newer API) has no entry, and emailLine then says nothing rather than
// "undefined sent".
const EMAIL_NAMES: Record<AppointmentEmail['kind'], string> = {
  confirmation: 'Confirmation',
  reminder: 'Reminder',
  rescheduled: 'Update',
  cancelled: 'Cancellation',
  review_request: 'Review request',
  deposit_request: 'Deposit link',
  refund: 'Refund email',
}

// emailLine says what happened to the most recent email about an appointment
// that was meant to go; empty when there is nothing worth saying. A skipped one
// no longer applied, and the client never saw it.
export function emailLine(emails: AppointmentEmail[]): string {
  const last = emails.filter((e) => e.status !== 'skipped').pop()
  if (!last) return ''
  const what = Object.prototype.hasOwnProperty.call(EMAIL_NAMES, last.kind) ? EMAIL_NAMES[last.kind] : ''
  if (!what) return ''
  switch (last.status) {
    case 'sent':
      return `${what} sent`
    case 'pending':
      return `Sending ${what.toLowerCase()}…`
    case 'failed':
      return `${what} didn’t send`
    default:
      return ''
  }
}

export function failedConfirmation(emails: AppointmentEmail[]): boolean {
  return emails.some((e) => e.kind === 'confirmation' && e.status === 'failed')
}

export function reviewLine(review: { rating: number | null } | null): string {
  return review?.rating ? `Review received · ${review.rating} ${review.rating === 1 ? 'star' : 'stars'}` : ''
}
